import type {SplitCodeownersError} from '@github-ui/code-view-types'
import {createContext, use} from 'react'

const SplitCodeownersErrorsContext = createContext<SplitCodeownersError[]>([])

export default SplitCodeownersErrorsContext

export function useSplitCodeownersErrorsContext() {
  return use(SplitCodeownersErrorsContext)
}
